import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class generalService extends ApiBaseService {
  constructor(http: HttpClient) {
    super(http, '/general');
  }
}
